module.exports = __webpack_public_path__ + "static/media/l_dot_6.b8bdd4f1.png";